import { RegistryItem } from "@schemas/agreementconditions/schema";
import { AgreementConditionType } from "__generated__/graphql";


export const ProductSchema: RegistryItem = {
	[AgreementConditionType.Product]: {
		fields: {
			"conditions.product": {
				path: "product",
				rules: {
					required: true,
				},
			},
		},
		toInput: (form) => ({
			product: form.product?.id,
		}),
		toForm: (condition) => ({
			product: condition.product ?? undefined,
		}),
	},
};
